import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/shared/Layout';
import ScrollToTop from './components/ScrollToTop';
import GlobalClickHandler from './components/shared/GlobalClickHandler';
import Home from './pages/Home';
import NewsInsights from './components/news-insights/NewsInsights';
import AboutUs from './components/about/AboutUs';
import Careers from './components/careers/Careers';
import JobDetails from './components/careers/JobDetails';
import OpsAssist from './components/our-offerings/OpsAssist';
import CaseStudies from './components/our-offerings/CaseStudies';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <GlobalClickHandler />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/news-insights" element={<NewsInsights />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/job-details" element={<JobDetails />} />
          <Route path="/job-details/:jobId" element={<JobDetails />} />
          <Route path="/ops-assist" element={<OpsAssist />} />
          <Route path="/case-studies" element={<CaseStudies />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;


